import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from '../security/auth.interceptor'

export const httpInterceptorProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
]
